export const PUBLISHER_SEARCH = {
  BUTTONS: {
    BACK: 'Back',
    UPDATE: 'Update Custom List',
    CLEAR: 'Clear Form',
  },
  FILTER: 'Filters',
};
